import React, { useEffect, useRef, useState } from 'react';
import RequiredSection from './RequiredSection';
import OptionsSection from './OptionsSection';
import Scrollbars from 'react-custom-scrollbars-2';
import IntlMessages from 'Util/IntlMessages';
import { getApplyMy, getRecruitmentConfig, putApplyMy } from 'Api/endpoints/Recruitment';
import icArrowWhite from 'Assets/img/recruitment/ic_arrow_white.png';
import icArrowWhite2 from 'Assets/img/recruitment/ic_arrow_white@2x.png';
import icArrowWhite3 from 'Assets/img/recruitment/ic_arrow_white@3x.png';
import topButton from 'Assets/img/recruitment/top_btn.png';
import topButton2 from 'Assets/img/recruitment/top_btn@2x.png';
import topButton3 from 'Assets/img/recruitment/top_btn@3x.png';
import { getImageSet, getOnlyNumber, numberFormat, removeEmpty } from 'Util/DataUtils';
import LoginPopup from './LoginPopup';
import { useDispatch, useSelector } from 'react-redux';
import { setConfigRecruitment } from 'Actions/ConfigActions';
import { stringToDate, convertISOformatOnlyDateUTC } from 'Util/DateUtils';
import { postLogout } from 'Api/endpoints/Auth';
import { logoutUser } from 'Actions/AuthActions';
import Footer from 'Components/Footer/Footer';
import LogoSection from './LogoSection';
import JoinPopup from './JoinPopup';
import CommonPopup from 'Components/Popup/CommonPopup';
import _ from 'lodash';
import Helmet from 'Components/common/Helmet';
import CommonDialog from 'Components/Popup/CommonDialog';
import { useError } from 'Api/hooks/useError';

const EMAIL_REGEX = /^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/;
const TYPE_REQUIRED = 'TYPE_REQUIRED';
const TYPE_OPTIONS = 'TYPE_OPTIONS';
const arrows = getImageSet([icArrowWhite, icArrowWhite2, icArrowWhite3]);
const topButtons = getImageSet([topButton, topButton2, topButton3]);
const defaultUserInfo = () => ({
  companyName: '',
  businessOwner: '',
  imageBusinessRegistration: '',
  email: '',
  managerPhone: '',
  businessPhone: '',
  businessAddress: '',
  businessAddress2: '',
  latitude: '',
  longitude: '',
});
const defaultRecruitInfo = () => ({
  typeOfWorks: [],
  constructionAreas: [],
  dateEstablishment: '',
  numOfEmployee: '',
  constructionExperience: '',
  constructionSpaceTypes: [],
  capitalStock: 0,
  majorClients: [],
  companyHistories: [],
  portfolios: [],
  introduce: '',
  docs: [],
  businessType: '',
  logo: '',
});

const RecruitmentJoin = () => {
  const { showErrorPopup } = useError();
  const authUser = useSelector(store => store.authUser);
  const dispatch = useDispatch();
  const scrollRef = useRef();
  const footerRef = useRef();
  const [type, setType] = useState(TYPE_REQUIRED);
  const [scrollTop, setScrollTop] = useState(false);
  const [isTop, setIsTop] = useState(true);
  const [openLoginPopup, setOpenLoginPopup] = useState(false);
  const [openJoinPopup, setOpenJoinPopup] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [recruitInfo, setRecruitInfo] = useState(null);
  const [isShowError, setIsShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isShowSave, setIsShowSave] = useState(false);
  // const [isAutoSave, setIsAutoSave] = useState(false);
  const [scrollFooter, setScrollFooter] = useState(false);
  const { dialogData } = useSelector(state => state.loading);

  // const autoSave = async () => {
  //   if (!authUser.token) return;
  //   const copiedUserInfo = removeEmpty(_.cloneDeep(userInfo));
  //   const copiedRecruitInfo = removeEmpty(_.cloneDeep(recruitInfo));
  //   if (copiedRecruitInfo.capitalStock) {
  //     copiedRecruitInfo.capitalStock = numberFormat(copiedRecruitInfo.capitalStock);
  //   }
  //   if (copiedRecruitInfo.dateEstablishment) {
  //     copiedRecruitInfo.dateEstablishment = stringToDate(copiedRecruitInfo.dateEstablishment);
  //   }
  //   if (
  //     !copiedUserInfo.companyName ||
  //     !copiedUserInfo.businessOwner ||
  //     !copiedUserInfo.email ||
  //     !EMAIL_REGEX.test(copiedUserInfo.email) ||
  //     !copiedUserInfo.imageBusinessRegistration ||
  //     !copiedRecruitInfo.typeOfWorks ||
  //     copiedRecruitInfo.typeOfWorks?.length === 0 ||
  //     !copiedRecruitInfo.constructionSpaceTypes ||
  //     copiedRecruitInfo.constructionSpaceTypes.length === 0 ||
  //     !copiedRecruitInfo.constructionAreas ||
  //     copiedRecruitInfo.constructionAreas?.length === 0 ||
  //     !copiedRecruitInfo.dateEstablishment ||
  //     copiedRecruitInfo.dateEstablishment === 'Invalid date' ||
  //     !copiedRecruitInfo.numOfEmployee ||
  //     !copiedRecruitInfo.businessType ||
  //     !copiedRecruitInfo.constructionExperience
  //   ) {
  //     return;
  //   }
  //   for (let i = 0; i < copiedRecruitInfo.companyHistories.length; i++) {
  //     const item = copiedRecruitInfo.companyHistories[i];
  //     item.date = stringToDate(item.date);
  //     if (!item.memo) {
  //       delete item.memo;
  //     }
  //     if (!item.content || !item.date || item.date === 'Invalid date') {
  //       return;
  //     }
  //   }

  //   for (let i = 0; i < copiedRecruitInfo.portfolios.length; i++) {
  //     const item = copiedRecruitInfo.portfolios[i];
  //     item.dateStart = stringToDate(item.dateStart);
  //     item.dateEnd = stringToDate(item.dateEnd);

  //     if (!item.fieldName || !item.client || !item.dateStart || item.dateStart === 'Invalid date' || !item.dateEnd || item.dateEnd === 'Invalid date') {
  //       return;
  //     }
  //   }
  //   try {
  //     const result = await putApplyMy({ userInfo: copiedUserInfo, recruitInfo: copiedRecruitInfo });
  //     if (result.data) {
  //       setIsAutoSave(true);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // useInterval(() => {
  //   autoSave();
  // }, 30000);

  // useEffect(() => {
  //   if (isAutoSave) {
  //     setTimeout(function () {
  //       setIsAutoSave(false);
  //     }, 2000);
  //   }
  // }, [isAutoSave]);

  const getConfig = async () => {
    if (!authUser.token) return;
    const phoneCountry = authUser.user.phoneCountry;
    try {
      const result = await getRecruitmentConfig({ phoneCountry });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      dispatch(setConfigRecruitment(result.data));
    } catch (e) {
      console.log(e);
    }
  };

  const setMeInfo = async () => {
    let required = defaultUserInfo();
    let options = defaultRecruitInfo();
    try {
      if (authUser.token) {
        const result = await getApplyMy();
        if (result.err) {
          showErrorPopup({ text: result.err.response.data.message });
          return;
        }
        const {
          partner: { materialBuyer = {} },
          email,
        } = result.data;
        const { managerPhone, businessAddress, businessAddress2, businessOwner, companyName, location, imageBusinessRegistration, businessPhone, recruitInfo = {} } = materialBuyer;
        const {
          typeOfWorks,
          constructionAreas,
          dateEstablishment,
          numOfEmployee,
          businessType,
          constructionExperience,
          constructionSpaceTypes,
          capitalStock,
          majorClients,
          companyHistories,
          portfolios,
          introduce,
          docs,
          logo,
        } = recruitInfo;
        required = {
          ...required,
          ...(companyName && { companyName }),
          ...(businessOwner && { businessOwner }),
          ...(imageBusinessRegistration && { imageBusinessRegistration }),
          ...(email && { email }),
          ...(managerPhone && { managerPhone: getOnlyNumber(managerPhone) }),
          ...(businessPhone && { businessPhone: getOnlyNumber(businessPhone) }),
          ...(businessAddress && { businessAddress }),
          ...(businessAddress2 && { businessAddress2 }),
          ...(location && {
            latitude: location.coordinates[1],
            longitude: location.coordinates[0],
          }),
        };
        options = {
          ...options,
          ...(typeOfWorks && { typeOfWorks }),
          ...(constructionAreas && { constructionAreas }),
          ...(dateEstablishment && { dateEstablishment: stringToDate(dateEstablishment) }),
          ...(numOfEmployee && { numOfEmployee }),
          ...(businessType && { businessType }),
          ...(constructionExperience && { constructionExperience }),
          ...(constructionSpaceTypes && { constructionSpaceTypes }),
          ...(capitalStock && { capitalStock: numberFormat(capitalStock, false, false, true) }),
          ...(logo && { logo }),
          ...(majorClients && { majorClients }),
          ...(companyHistories && {
            companyHistories: companyHistories.map(({ _id, date, ...rest }) => ({
              content: '',
              memo: '',
              ...rest,
              date: stringToDate(date),
            })),
          }),
          ...(portfolios && {
            portfolios: portfolios.map(({ _id, dateStart, dateEnd, ...rest }) => ({
              fieldName: '',
              client: '',
              images: [],
              ...rest,
              dateStart: stringToDate(dateStart),
              dateEnd: stringToDate(dateEnd),
            })),
          }),
          ...(introduce && { introduce }),
          ...(docs && { docs: docs.map(({ _id, ...rest }) => rest) }),
        };
      }
    } catch (e) {
      console.log(e);
    }
    setUserInfo(required);
    setRecruitInfo(options);
  };

  useEffect(() => {
    getConfig();
    setMeInfo();
  }, []);

  const onUpdateScroll = ({ top, clientHeight, scrollHeight, scrollTop: scrollFromTop }) => {
    const maxScroll = scrollHeight - clientHeight;
    const footerHeight = footerRef.current?.offsetHeight || 0;
    if (scrollFromTop > maxScroll - footerHeight && !scrollFooter) {
      setScrollFooter(true);
    }
    if (scrollFromTop < maxScroll - footerHeight && scrollFooter) {
      setScrollFooter(false);
    }
    if (top !== 0 && isTop) {
      setIsTop(false);
    }
    if (top === 0 && !isTop) {
      setIsTop(true);
    }
    if (scrollTop) {
      scrollRef.current.scrollToTop();
      setScrollTop(false);
    }
  };

  const onChangeUserInfo = ({ name, value: preValue }) => {
    if (!authUser || !authUser.token) {
      setOpenLoginPopup(true);
      return;
    }
    let value = preValue;
    if (name === 'managerPhone' || name === 'businessPhone') {
      value = getOnlyNumber(value);
    }
    setUserInfo(x => ({ ...x, [name]: value }));
  };

  const onChangeRecruitInfo = ({ name, value: preValue }) => {
    if (!authUser || !authUser.token) {
      setOpenLoginPopup(true);
      return;
    }
    let value = preValue;
    if (name === 'capitalStock') {
      value = numberFormat(value, false, false, true);
    }
    if (name === 'introduce' && value.length > 350) {
      return;
    }
    setRecruitInfo(x => ({ ...x, [name]: value }));
  };

  const onChangeMultiUserInto = data => {
    if (!authUser || !authUser.token) {
      setOpenLoginPopup(true);
      return;
    }
    setUserInfo(x => ({ ...x, ...data }));
  };

  const onClickLogout = async e => {
    e.preventDefault();
    try {
      const result = await postLogout();
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      setUserInfo(defaultUserInfo());
      setRecruitInfo(defaultRecruitInfo());
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(logoutUser());
      setOpenLoginPopup(false);
      setOpenJoinPopup(false);
    }
  };

  const showLocalErrorPopup = key => {
    setErrorMessage(`err.recruitment.${key}`);
    setIsShowError(true);
  };

  const onClickSave = async () => {
    // if (isAutoSave) return;
    const copiedUserInfo = removeEmpty(_.cloneDeep(userInfo));
    const copiedRecruitInfo = removeEmpty(_.cloneDeep(recruitInfo));

    if (copiedRecruitInfo.capitalStock) {
      copiedRecruitInfo.capitalStock = numberFormat(copiedRecruitInfo.capitalStock);
    }
    if (copiedRecruitInfo.dateEstablishment) {
      copiedRecruitInfo.dateEstablishment = convertISOformatOnlyDateUTC(copiedRecruitInfo.dateEstablishment);
    }

    if (!copiedUserInfo.companyName) {
      showLocalErrorPopup('companyName');
      return;
    } else if (!copiedUserInfo.businessOwner) {
      showLocalErrorPopup('businessOwner');
      return;
    } else if (!copiedUserInfo.email) {
      showLocalErrorPopup('email');
      return;
    } else if (!EMAIL_REGEX.test(copiedUserInfo.email)) {
      showLocalErrorPopup('email.2');
      return;
    } else if (!copiedUserInfo.imageBusinessRegistration) {
      showLocalErrorPopup('imageBusinessRegistration');
      return;
    } else if (!copiedRecruitInfo.typeOfWorks || copiedRecruitInfo.typeOfWorks?.length === 0) {
      showLocalErrorPopup('typeOfWorks');
      return;
    } else if (!copiedRecruitInfo.constructionSpaceTypes || copiedRecruitInfo.constructionSpaceTypes.length === 0) {
      showLocalErrorPopup('constructionSpaceTypes');
      return;
    } else if (!copiedRecruitInfo.constructionAreas || copiedRecruitInfo.constructionAreas?.length === 0) {
      showLocalErrorPopup('constructionAreas');
      return;
    } else if (!copiedRecruitInfo.dateEstablishment) {
      showLocalErrorPopup('dateEstablishment');
      return;
    } else if (copiedRecruitInfo.dateEstablishment === 'Invalid date') {
      showLocalErrorPopup('dateEstablishment.2');
      return;
    } else if (!copiedRecruitInfo.numOfEmployee) {
      showLocalErrorPopup('numOfEmployee');
      return;
    } else if (!copiedRecruitInfo.businessType) {
      showLocalErrorPopup('businessType');
      return;
    } else if (!copiedRecruitInfo.constructionExperience) {
      showLocalErrorPopup('constructionExperience');
      return;
    }

    for (let i = 0; i < copiedRecruitInfo.companyHistories.length; i++) {
      const item = copiedRecruitInfo.companyHistories[i];
      item.date = convertISOformatOnlyDateUTC(item.date);
      if (!item.memo) {
        delete item.memo;
      }
      if (!item.content || !item.date || item.date === 'Invalid date') {
        showLocalErrorPopup('companyHistories');
        return;
      }
    }

    for (let i = 0; i < copiedRecruitInfo.portfolios.length; i++) {
      const item = copiedRecruitInfo.portfolios[i];
      item.dateStart = convertISOformatOnlyDateUTC(item.dateStart);
      item.dateEnd = convertISOformatOnlyDateUTC(item.dateEnd);

      if (!item.fieldName || !item.client || !item.dateStart || item.dateStart === 'Invalid date' || !item.dateEnd || item.dateEnd === 'Invalid date') {
        showLocalErrorPopup('portfolios');
        return;
      }
    }

    try {
      const result = await putApplyMy({ userInfo: copiedUserInfo, recruitInfo: copiedRecruitInfo });
      if (result.data) {
        setIsShowSave(true);
      } else {
        showErrorPopup({ text: result.err.response.data.message });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Helmet subTitle={'recruitment.join.title'} />
      <Scrollbars onUpdate={onUpdateScroll} className="rct-scroll" autoHide autoHideDuration={100} ref={scrollRef}>
        <div className="recruitment-join-wrapper">
          <div className="recruitment-join-main">
            <div className="recruitment-join-title-wrapper">
              <div style={{ width: '146px' }} />
              <div className="recruitment-join-title">
                <IntlMessages id="recruitment.join.title" />
              </div>
              <div className="recruitment-join-title-button" onClick={() => window.open('/', '_blank')}>
                <IntlMessages id="recruitment.go.ERP" />
              </div>
            </div>
            <div className="recruitment-join-banner-wrapper">
              <LogoSection />
            </div>
            <div className="recruitment-join-body">
              <div className="recruitment-join-body-header">
                <div className="recruitment-join-body-header-left">
                  <div
                    className={`recruitment-join-body-header-left-button ${type === TYPE_REQUIRED && 'select'}`}
                    onClick={() => {
                      setType(TYPE_REQUIRED);
                      setScrollTop(true);
                    }}
                  >
                    <IntlMessages id="recruitment.join.required" />
                    {type === TYPE_REQUIRED && <div className="line" />}
                  </div>
                  <div
                    className={`recruitment-join-body-header-left-button ${type === TYPE_OPTIONS && 'select'}`}
                    onClick={() => {
                      setType(TYPE_OPTIONS);
                      setScrollTop(true);
                    }}
                  >
                    <IntlMessages id="recruitment.join.options" />
                    {type === TYPE_OPTIONS && <div className="line" />}
                  </div>
                </div>
                {authUser?.user ? (
                  <div className="recruitment-join-body-header-right-login">
                    <div>
                      <IntlMessages id="recruitment.user.name" values={{ user: userInfo?.companyName || '' }} />
                    </div>
                    <div className="recruitment-join-body-header-right-login-button" onClick={onClickLogout}>
                      <IntlMessages id="common.logout" />
                    </div>
                    <div className="recruitment-join-body-header-right-login-button join" onClick={onClickSave}>
                      {/* {isAutoSave ? <IntlMessages id="common.autoSave" /> : <IntlMessages id="consult.button.save" />} */}
                      <IntlMessages id="consult.button.save" />
                    </div>
                  </div>
                ) : (
                  <div className="recruitment-join-body-header-right">
                    <div className="recruitment-join-body-header-right-button" onClick={() => setOpenLoginPopup(true)}>
                      <IntlMessages id="sign.title" />
                    </div>
                    <div className="recruitment-join-body-header-right-button join" onClick={() => setOpenJoinPopup(true)}>
                      <IntlMessages id="sign.join" />
                    </div>
                  </div>
                )}
              </div>
              <div>
                {type === TYPE_REQUIRED ? (
                  <RequiredSection userInfo={userInfo} recruitInfo={recruitInfo} onChangeUserInfo={onChangeUserInfo} onChangeRecruitInfo={onChangeRecruitInfo} />
                ) : (
                  <OptionsSection
                    userInfo={userInfo}
                    recruitInfo={recruitInfo}
                    onChangeUserInfo={onChangeUserInfo}
                    onChangeRecruitInfo={onChangeRecruitInfo}
                    onChangeMultiUserInto={onChangeMultiUserInto}
                  />
                )}
              </div>
              <div className="recruitment-join-body-footer">
                {type === TYPE_REQUIRED && (
                  <div
                    className="recruitment-join-body-footer-button"
                    onClick={() => {
                      setType(TYPE_OPTIONS);
                      setScrollTop(true);
                    }}
                  >
                    <div className="recruitment-join-body-footer-button-text">
                      <IntlMessages id="consult.button.next" />
                    </div>
                    <img {...arrows} alt="arrow" />
                  </div>
                )}
                {type === TYPE_OPTIONS && (
                  <div
                    className="recruitment-join-body-footer-button"
                    onClick={() => {
                      setType(TYPE_REQUIRED);
                      setScrollTop(true);
                    }}
                  >
                    <img {...arrows} alt="arrow" style={{ transform: 'rotate(180deg)' }} />
                    <div className="recruitment-join-body-footer-button-text">
                      <IntlMessages id="consult.button.prev" />
                    </div>
                  </div>
                )}
              </div>
              {!isTop && (
                <div className={`recruitment-join-body-top-button ${scrollFooter && 'scroll-footer'}`} onClick={() => setScrollTop(true)}>
                  <img {...topButtons} alt="top-button" />
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer propRef={footerRef} />
        <LoginPopup
          open={openLoginPopup}
          onClose={() => setOpenLoginPopup(false)}
          onConfirm={() => {
            getConfig();
            setMeInfo();
          }}
          onPopupJoin={() => {
            setOpenJoinPopup(true);
          }}
        />
        <JoinPopup
          open={openJoinPopup}
          onClose={() => setOpenJoinPopup(false)}
          onConfirm={() => {
            setOpenLoginPopup(true);
          }}
        />
        <CommonPopup
          show={isShowError}
          needIntl
          title={errorMessage}
          imageType="wa"
          onClose={() => {
            setIsShowError(false);
            setErrorMessage('');
          }}
          cancelText="button.confirm"
        />
        <CommonPopup
          show={isShowSave}
          needIntl
          title="message.save"
          imageType="su"
          onClose={() => {
            setIsShowSave(false);
          }}
          cancelText="button.confirm"
        />
        <CommonDialog {...dialogData} />
      </Scrollbars>
    </>
  );
};

export default RecruitmentJoin;
